import React, { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase/config';

const JUMPSCARE_GIF =
  'https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExYmliMG1iZzJ2ZzZ0c2s5NHNlbmNhb3dubTVodHB1dDV3OHE4cmxqMyZlcD12MV9naWZzX3NlYXJjaCZjdD1n/s0OXfMFqNC2QdfNPGx/giphy.gif';

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showJumpscare, setShowJumpscare] = useState(false);

  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    try {
      await signInWithEmailAndPassword(auth, email.trim(), password.trim());
      navigate('/dashboard');
    } catch (err) {
      console.error('Login failed:', err);
      setError('Incorrect email or password.');
      setShowJumpscare(true);

      setTimeout(() => {
        setShowJumpscare(false);
      }, 2500);
    }
  };

  return (
    <>
      <div style={{ textAlign: 'center', padding: '20px' }}>
        {/* Header Video */}
        <video
          src="/assets/giphy.mp4"
          autoPlay
          controls
          loop
          muted
          playsInline
          style={{ width: '100%', maxWidth: '400px', marginBottom: '20px' }}
        />

        {/* Login Form */}
        <form onSubmit={handleLogin}>
          <h1>GO GO GO KUPAL!</h1>
          <div>
            <label>Email:</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="Email"
            />
          </div>
          <div>
            <label>Password:</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="Password"
            />
          </div>
          {error && <p style={{ color: 'red' }}>{error}</p>}
          <button type="submit">Login</button>
        </form>
      </div>

      {/* Jumpscare GIF Fullscreen */}
      {showJumpscare && (
        <div
          className="jumpscare-modal"
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'black',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <img
            src={JUMPSCARE_GIF}
            alt="Jumpscare"
            style={{
              maxWidth: '90%',
              maxHeight: '90%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}
    </>
  );
};

export default Login;
